import { useRecordContext } from 'react-admin';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'

import { useEffect, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const KMLTrackField = ({ source }) => {
    const record = useRecordContext();
    const [kmlData, setKmlData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function loadKML() {
            if (record && record[source]) {
                console.log("Raw KML Data:", record[source]); // Debugging

                try {
                    // Dynamically import leaflet-kml
                    const { default: L } = await import("leaflet");
                    await import("leaflet-kml");

                    const parser = new DOMParser();
                    const kml = parser.parseFromString(record[source], "text/xml");

                    if (!kml || kml.documentElement.nodeName === "parsererror") {
                        throw new Error("Invalid KML data");
                    }

                    console.log("Parsed KML Object:", kml); // Debugging

                    setKmlData(kml);
                } catch (err) {
                    console.error("Error processing KML:", err); // Debugging
                    setError(err.message);
                }
            }
        }
        loadKML();
    }, [record, source]);

    if (!record || !record[source]) return <span>No track available</span>;
    if (error) return <span style={{ color: 'red' }}>Error: {error}</span>;
    const position = [51.505, -0.09]

    return (
        <MapContainer center={position} zoom={13} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            A pretty CSS3 popup. <br />
          </Popup>
        </Marker>
      </MapContainer>
    );
};

export default KMLTrackField;
